/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { SalesWrap } from './SalesWrap';
import {
    SalesWrapFromJSON,
    SalesWrapFromJSONTyped,
    SalesWrapToJSON,
} from './SalesWrap';

/**
 * 
 * @export
 * @interface SalesWrapPagable
 */
export interface SalesWrapPagable {
    /**
     * Array of items
     * @type {Array<SalesWrap>}
     * @memberof SalesWrapPagable
     */
    items?: Array<SalesWrap>;
    /**
     * 
     * @type {Pageable}
     * @memberof SalesWrapPagable
     */
    meta?: Pageable;
}

/**
 * Check if a given object implements the SalesWrapPagable interface.
 */
export function instanceOfSalesWrapPagable(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SalesWrapPagableFromJSON(json: any): SalesWrapPagable {
    return SalesWrapPagableFromJSONTyped(json, false);
}

export function SalesWrapPagableFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesWrapPagable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(SalesWrapFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PageableFromJSON(json['meta']),
    };
}

export function SalesWrapPagableToJSON(value?: SalesWrapPagable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(SalesWrapToJSON)),
        'meta': PageableToJSON(value.meta),
    };
}

